import useFetchByParams from 'shared/hooks/useFetchByParams';
import { useMemo } from 'react';
import { fetchPlatforms, selectPlatforms, selectPlatformsLoading } from 'app/store/slices/platform.slice';
import { QueryParams } from 'shared/types';
import { Platform } from 'shared/models';

export const usePlatformQuery = (query?: QueryParams) => {
  return useMemo(() => {
    const queryParams = { ...query, limit: 'unlimited' };

    return [queryParams];
  }, []);
};

export const usePlatforms = (query: QueryParams) => {
  return useFetchByParams<Platform[]>({
    action: fetchPlatforms,
    dataSelector: selectPlatforms,
    loadingSelector: selectPlatformsLoading,
    params: query,
  });
};
